// Socios variables
import socios from '@webapp/socios.json';

import {
    isWithinInterval,
} from '@shared/utils/dates';
import Regulation from '@shared/types/regulation';

// Store
import store from '@webapp/store/index.js';

// Config
import {
    PERMISSION_CODE,
} from '@shared/config/user-permissions';

import localStoreTypes from '@webapp/store/types.js';

export const getPartnerPageBuySellButtons = ({
    partner: {
        id: partnerId = '',
    } = {},
    voteTokenOfferings = [],
    markets = [],
    hasSellHidden,
    hasBuyHidden = false,
    $vue,
}) => {
    const buttons = [];
    const hasMarket = markets.some((market) => market.partnerId === partnerId);

    // If the Partner has an active FTO, show the BUY FTO button
    if (isFTOActive(voteTokenOfferings[0]) && !hasBuyHidden) {
        buttons.push({
            class: 'button--green',
            label: $vue.$t('global.button.buy'),
            route: `/buy-fto/${partnerId}`,
        });
    }

    // If FTO is not active and the Token is being traded, show the BUY and SELL buttons
    if (!isFTOActive(voteTokenOfferings[0]) && hasMarket) {
        if (!hasBuyHidden) {
            buttons.push({
                class: 'button--orange',
                label: $vue.$t('marketplace.trading.buy'),
                route: `/buy-ft/${partnerId}`,
                disabled: false,
            });
        }

        if (!hasSellHidden) {
            buttons.push({
                class: 'button--blue',
                label: $vue.$t('marketplace.trading.sell'),
                route: `/sell-ft/${partnerId}`,
            });
        }
    }

    return buttons;
};

export const getBuyTokenLink = ({
    partner: {
        id: partnerId = '',
    } = {},
    voteTokenOfferings = [],
    markets = [],
}) => {
    const hasMarket = markets.some((market) => market.partnerId === partnerId);

    // If the Partner has an active FTO, return the BUY FTO link
    if (isFTOActive(voteTokenOfferings[0])) {
        return `/buy-fto/${partnerId}`;
    }

    // If the FTO is not active and the Token is being traded, return BUY FT link
    if (!(isFTOActive(voteTokenOfferings[0])) && hasMarket) {
        return `/buy-ft/${partnerId}`;
    }

    return null;
};

const isFTOActive = (voteTokenOffering) => voteTokenOffering &&
    socios.showFto &&
    ['opened', 'published'].includes(voteTokenOffering.status) &&
    isWithinInterval(Date.now(), {
        start: new Date(voteTokenOffering.startDate),
        end: new Date(voteTokenOffering.endDate),
    });

/**
 * Handling of the trading restriction disclaimer based on whether it was already shown or not
 *
 * @param {object} vm - Vue instance
 * @param {object} param1 - Selected partner object
 * @param {string} param1.shortName - Destructured partner short name
 * @returns {void} - void
 */
export const handleShowingOfPartnerDisclaimer = (vm, { shortName }) => {
    const storedConfig = JSON.parse(localStorage.getItem('partnerDisclaimer')) ?? {};

    if (storedConfig[shortName]) {
        return;
    }

    vm.$store.dispatch(localStoreTypes.SET_MODAL, {
        isClosable: false,
        isVisible: true,
        image: require('@webapp/assets/globe.webp'),
        title: vm.$t('partner.tradingRestrictions'),
        messages: [
            {
                text: vm.$t('partner.tradingRestrictionsInfo'),
            },
        ],
        acceptButton: {
            text: vm.$t('global.button.continue'),
            action: () => {
                localStorage.setItem('partnerDisclaimer', JSON.stringify({
                    ...storedConfig,
                    [shortName]: true,
                }));

                vm.$store.dispatch(localStoreTypes.RESET_MODAL);
            },
        },
    });
};

export const getSuggestions = ({
    teamId,
    vue,
    currentRegulation,
}) => {
    const isPredictorEnabled = store.getters['serverConfig/serverConfigByKey']('isWebSportEventsEnabled') &&
        !vue.isFeatureDenied(PERMISSION_CODE.PREDICTOR_ACCESS);
    const isCheckinEnabled = vue.remoteConfigByKey('isCheckinEnabled') && vue.remoteConfigByKey('isWebCheckInEnabled') &&
        !vue.isFeatureDenied(PERMISSION_CODE.CHECKIN_ACCESS);

    switch (currentRegulation) {
        case Regulation.International:
        case Regulation.Usa:
        default:
            return [
                {
                    icon: 'survey',
                    title: vue.$t('global.polls.poll'),
                    subtitle: vue.$t('global.polls.pollHint'),
                    onPress: () => {
                        vue.$router.push('/polls');
                    },
                },
                ...(isPredictorEnabled && teamId ? [
                    {
                        icon: 'prediction',
                        title: vue.$t('predictors.predictorMain'),
                        subtitle: vue.$t('predictors.predictorHint'),
                        onPress: () => {
                            vue.$router.push(`/predictor/team/${teamId}`);
                        },
                    },
                ] : []),
                ...(isCheckinEnabled && teamId ? [
                    {
                        icon: 'checkin',
                        title: vue.$t('checkIn.details.actionBarTitle'),
                        subtitle: vue.$t('checkIn.details.checkInExplanation'),
                        onPress: () => {
                            // Go to check-in
                        },
                    },
                ] : []),
            ];
    }
};